// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes dash-5ffffef0{0%{stroke-dashoffset:100}to{stroke-dashoffset:0}}.timer-circle[data-v-5ffffef0]{transform:rotate(-90deg)}.timer-circle--reset-on-hover:hover circle[data-v-5ffffef0]{display:none}.timer-circle circle[data-v-5ffffef0]{stroke-dasharray:100 100;stroke-dashoffset:50;animation-iteration-count:infinite;animation-name:dash-5ffffef0;animation-timing-function:linear;transition:stroke-dashoffset .2s linear}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
